__turbopack_context__.v({
  "className": "caveat_eb60d57a-module__FnVHBq__className",
});
